
export default Object.freeze({
  BOOLEAN_SCALE: 1e12,
  // EPSILON: Number.EPSILON
  EPSILON: 1e-8
});



// WEBPACK FOOTER //
// ./src/assets/javascripts/Consts.js